import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ID } from '../../utils/id'
import { COMPANY_FRAGMENT, CompanyFragment } from '../fragment/company.fragment'

interface Data {
  company: CompanyFragment
}

interface Variables {
  id: ID
}

const QUERY = gql`
  query getCompany($id: ID!) {
    company: getCompanyById(id: $id) {
      ...Company
    }
  }

  ${COMPANY_FRAGMENT}
`

export const useCompanyQuery = (
  options: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> => useQuery<Data, Variables>(QUERY, options)
